import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { ConfigService } from '../../../../utils/config-service';
import { Observable } from 'rxjs/Observable';
import { Dashboard, CreateUpdateDashboardModel } from '../../models/dashboard';

@Injectable()
export class DashboardApiService {
    private readonly dashboardApiUrl: string;
    private readonly dashboardUrl: string;

    constructor(private http: HttpClient, private configService: ConfigService) {
        this.dashboardApiUrl = this.configService.getEnv('dashboardApi');
        this.dashboardUrl = this.configService.getEnv('dashboard');
    }

    getAllDashboards(): Observable<Dashboard[] | {}> {
        return this.http.get(this.dashboardApiUrl)
            .map((result: any) => {
                return result.map((json: any) => new Dashboard(json, this.dashboardUrl));
            }).catch((error: any) => {
                throw error;
            });
    }

    createDashboard(dashboard: CreateUpdateDashboardModel): Observable<string> {
        return this.http.post(this.dashboardApiUrl, JSON.stringify(dashboard), { headers: this.getHeaders() })
            .map((result: any) => {
                return result.id;
            }).catch((error: any) => {
                throw error;
            });
    }

    updateDashboard(dashboard: CreateUpdateDashboardModel): Observable<any> {
        const url = this.dashboardApiUrl + dashboard.id;
        return this.http.put(url, dashboard, { headers: this.getHeaders() })
            .map((result: any) => {
                return result;
            }).catch((error: any) => {
                throw error;
            });
    }

    deleteDashboard(dashboardId: string): Observable<any> {
        return this.http.delete(this.dashboardApiUrl + dashboardId)
            .map((result: any) => {
                return result;
            }).catch((error: any) => {
                throw error;
            });
    }

    DeleteDashboardLogo(dashboardId: string): Observable<any> {
        return this.http.delete(this.dashboardApiUrl + `logo/${dashboardId}`);
    }

    private getHeaders(): HttpHeaders {
        return new HttpHeaders({ 'Content-Type': 'application/json' });
    }
}



// WEBPACK FOOTER //
// ./src/app/modules/domain/services/dashboard/dashboard.api.service.ts